import { type AdminFlag } from '@libraries/typescript/api_client';

export function readFlagBoolean(flag: AdminFlag | undefined): boolean {
    if (!flag) {
        return false;
    }
    const value = flag.current_value ?? flag.default_value;
    return value === true;
}
